import { render, staticRenderFns } from "./editWorkSetup.vue?vue&type=template&id=840bed76&scoped=true&lang=html&"
import script from "./editWorkSetup.vue?vue&type=script&lang=js&"
export * from "./editWorkSetup.vue?vue&type=script&lang=js&"
import style0 from "./editWorkSetup.vue?vue&type=style&index=0&id=840bed76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840bed76",
  null
  
)

export default component.exports